import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <div className="w-9 h-9 flex items-center justify-center bg-background-50/20 rounded-lg transition-transform group-hover:scale-105">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-background-50/70 text-sm leading-relaxed">
              {siteInfo.tagline}
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a
                href={siteInfo.socialLinks.weibo}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 hover:bg-background-50/20 transition-colors"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 hover:bg-background-50/20 transition-colors"
                aria-label="微信"
              >
                <i className="ri-wechat-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">
              视频分类
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-background-50/70 hover:text-background-50 text-sm transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-background-50/70 hover:text-background-50 text-sm transition-colors"
                >
                  网站首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-background-50/70 hover:text-background-50 text-sm transition-colors"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/category/parent-child-education"
                  className="text-background-50/70 hover:text-background-50 text-sm transition-colors"
                >
                  热门推荐
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-background-50/70 hover:text-background-50 text-sm transition-colors"
                >
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2 text-sm text-background-50/70">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5"></i>
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-50/60 text-sm">
            &copy; {currentYear} {siteInfo.name} 版权所有
          </p>
          <div className="flex items-center gap-4 text-sm text-background-50/60">
            <a href="#" className="hover:text-background-50/80 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-background-50/80 transition-colors">使用条款</a>
            <a href="#" className="hover:text-background-50/80 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}